var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7,20.3l-6-6.05a1,1,0,0,0-1.42,0,6.12,6.12,0,0,1-8,.26A5.79,5.79,0,0,1,5,6.83a6.09,6.09,0,0,1,7.65-2.25,5.84,5.84,0,0,1,3.26,7.1l.35.1h0l.34.11h0l.9.27h0l.35.1a7.88,7.88,0,0,0-4.21-9.47A8.17,8.17,0,0,0,3.42,5.44,7.8,7.8,0,0,0,4.56,15.71a8.23,8.23,0,0,0,10.28.62l5.44,5.39A1,1,0,0,0,21,22a1,1,0,0,0,.71-.28A1,1,0,0,0,21.7,20.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.082465b6382e83a5a46ce84d0e1b99ab.svg";
export { ForwardRef as ReactComponent };